import React from "react";
import { useTenantConfig } from "../../admin/components/TenantThemeProvider";
import { STATIC_LOGO_PATH } from "../../utils/branding";
import styles from "./ChatCanvasEmptyState.module.css";

export type ChatCanvasEmptyStateProps = {
  clearanceNotice?: string | null;
};

export function ChatCanvasEmptyState({ clearanceNotice }: ChatCanvasEmptyStateProps) {
  const { tenantConfig, loading } = useTenantConfig();
  const branding = {
    logoPath: STATIC_LOGO_PATH,
    appTitle: "Knowledge base",
    appName: "Cortex",
  };

  if (loading && !tenantConfig) {
    return null;
  }

  return (
    <div className={styles.emptyState} data-testid="chat-canvas-empty-state">
      <img
        src={branding.logoPath}
        className={styles.logo}
        alt={branding.appName}
      />
      {branding.appTitle ? <h1 className={styles.appTitle}>{branding.appTitle}</h1> : null}
      {clearanceNotice ? (
        <p data-testid="console-ceiling">{clearanceNotice}</p>
      ) : null}
    </div>
  );
}
